<template>
  <div class="c-box mb-1 mt-px">
    <a-tabs type="card" class="mt-4">
      <a-tab-pane
        v-for="tabCd in sortedGaleryTabs"
        :key="tabCd"
        :tab="sortedGalery[tabCd][0].imageCategoryNm"
      >
        <div>
          <div
            v-if="sortedGalery[tabCd] && sortedGalery[tabCd].length > 0"
            class="photo-list"
          >
            <div class="photo-list-container">
              <div
                v-for="(item, index) in sortedGalery[tabCd]"
                :key="`photo-list-item-${index}`"
                class="photo-list-item"
                @click="showPhotoGallery(index, sortedGalery[tabCd])"
              >
                <div
                  class="photo-list-item-img"
                  :style="{ 'background-image': `url(${getImgUrl(item)})` }"
                ></div>
                <p class="photo-list-item-text">{{ item.imageExplanation }}</p>
              </div>
            </div>
          </div>
          <div v-else class="pb-5">
            <a-list :data-source="[]" />
          </div>
        </div>
      </a-tab-pane>
    </a-tabs>
    <GalleryViewPopup
      :visible="showGallery"
      :numberOfImage="false"
      :value="showingGroup"
      :imageIndex="imageIndex"
      @ok="hidePhotoGalery"
      @close="hidePhotoGalery"
    />
  </div>
</template>
<script>
import { get, cloneDeep, isEmpty, groupBy, orderBy } from 'lodash'
import { SAVE_DATA_BS_APP_02_001 } from '@/store/modules/bs_app/actions'

import GalleryViewPopup from './components/GalleryViewPopup'

export default {
  components: {
    GalleryViewPopup
  },
  setup() {},
  data() {
    return {
      galleryData: [],
      showGallery: false,
      imageIndex: undefined,
      showingGroup: []
    }
  },
  created() {
    this.breadcrumbs = cloneDeep(get(this.$route, 'meta.breadcrumbs', []))
    this.$store.dispatch(SAVE_DATA_BS_APP_02_001, null)
  },
  async beforeMount() {
    await this.getPhotoGallery()
  },
  computed: {
    sortedGalery() {
      if (isEmpty(this.galleryData)) return []
      return groupBy(this.galleryData, 'imageCategoryCd') || []
    },
    sortedGaleryTabs() {
      if (isEmpty(this.galleryData)) return []
      return Object.keys(this.sortedGalery).sort()
    }
  },
  methods: {
    async getPhotoGallery() {
      const { menuNo } = this.$route.params
      this.$loading.show()
      const result = await this.$repositories('menu').getPhotoGallery(menuNo)
      this.$loading.hide()
      this.galleryData = result.data || []
    },
    getImgUrl(filename) {
      if (filename && filename.imageUrl) {
        return filename.imageUrl
      }
      return require('@/assets/images/slide-img-placeholder.png')
    },
    showPhotoGallery(index, group) {
      this.showGallery = true
      this.imageIndex = index
      this.showingGroup = group
    },
    hidePhotoGalery() {
      this.showGallery = false
      this.imageIndex = null
      this.showingGroup = []
    }
  }
}
</script>

<style lang="scss" scoped>
@import './style.scss';
</style>
